import { useEffect, useRef } from "react";  
import { timeAgo } from "../services/helperFunctions";
import favicon from '../assets/favicon.png';
import user from '../assets/user.png'; 
import Iframe from 'react-iframe';

export const isImageMessage = (messageContent) => {
  if (typeof messageContent !== 'string') {
    return false;
  }

  // Check for base64 data URL prefix
  if (messageContent.startsWith('data:image/')) {
    return true;
  }

  // Check for common image file extensions in URLs (case-insensitive)
  const lowerCaseContent = messageContent.toLowerCase();
  if (lowerCaseContent.endsWith('.jpg') || lowerCaseContent.endsWith('.jpeg') || lowerCaseContent.endsWith('.png') || lowerCaseContent.endsWith('.gif') || lowerCaseContent.endsWith('.bmp') || lowerCaseContent.endsWith('.webp')) {
    return true;
  }

  // Keep the specific 'wp_media_' check if it's a known indicator from your backend/API
  return messageContent.includes('wp_media_');
};

const Message = ({ message }) => {  
  const ref = useRef();  

  useEffect(() => {
    ref.current?.scrollIntoView({ behaviour: "smooth" });
  }, [message]);
 

  return (
    <>
      <div 
        ref={ref}
        className={`chat ${
          message.direction == 0 ? "chat-start" : "chat-end"
        }`}
      >
        <div className="chat-image avatar">
          <div className="w-10 rounded-full">
            <img
              src={message.direction == 1 ? favicon : user}
            />
          </div>
        </div>
        <div className="chat-header"> 
          <span className="text-sm font-semibold text-gray-700 mr-1">
            {message.name}
          </span>
          <time className="mx-1 text-xs opacity-50 object-cover">
            {timeAgo(message.timestamp)} {message.direction == 0 ? "" :  " | " + (message.state != undefined ? message.state.toUpperCase() : message.state)}
          </time>
        </div>
        <div className={`chat-bubble ${message.direction == 0 ? "bg-gray-200 text-gray-800" : "bg-sky-500 text-white"}`}>
          {isImageMessage(message.message) ? (
            <img src={message.message} alt="media" />
          ) : message.message.includes("longitude") && message.message.includes("latitude") ? (
            <Iframe
              url={`//maps.google.com/maps?q=${
                typeof message.message === "string"
                  ? JSON.parse(message.message).latitude
                  : message.message.latitude
              },${
                typeof message.message === "string"
                  ? JSON.parse(message.message).longitude
                  : message.message.longitude
              }&z=15&output=embed`}
              width="100%"
              height="300px"
              id=""
              style={{ width: "100%" }}
              className="border-[1px] border-solid border-neutral-200 rounded-lg"
              position="relative"
            />
          ) : (
            <span dangerouslySetInnerHTML={{ __html: message.message }} />
          )}
        </div>
      </div>
    </>
  );
};

export default Message;
